<template>
  <div class="mb-5 mt-4 flex justify-center">
    <img
      src="@/assets/edge-capacity.svg"
      alt="edge capacity logo"
    />
  </div>
  <div class="my-4 mb-4 w-full border-t border-light-gray md:border-none" />
  <layout>
    <h1 class="self-start py-1 text-left text-2xl text-dark-gray">
      Join this carrier
    </h1>
    <h1 class="self-start py-5 text-left text-xl text-dark-gray">
      Request Access
    </h1>
    <p class="mb-6 text-left text-dark-gray">
      For you to be able to join {{ carrierName }}, we need an authorized
      representative of the carrier to grant you access. If this carrier needs
      to be onboarded, you’ll be able to do so in the meantime.
    </p>
    <section v-if="!maskedContacts.length">
      <contact-recipients
        v-if="contactRecipients.length"
        title="Recipients of request"
        :show-see-more="false"
        :items-to-show="contactRecipients.length"
        :contacts="contactRecipients"
      />
    </section>
    <section v-else>
      <request-recipients
        title="Recipients of request"
        :items="maskedContacts"
      />
    </section>
    <button-main
      :is-loading="loading"
      @click="handleSubmit"
    >
      Send Request and Continue
    </button-main>
  </layout>
</template>

<script>
import ButtonMain from '@/components/Button.vue';
import Layout from '@/components/LoginLayout.vue';
import RequestRecipients from '@/views/signup/dispatcher/RequestRecipients.vue';
import ContactRecipients from '@/views/signup/dispatcher/ContactRecipients.vue';
import { toastResponse } from '@/common/handleServerResponse';

export default {
  name: 'JoinCarrier',
  components: {
    Layout,
    ButtonMain,
    ContactRecipients,
    RequestRecipients,
  },
  data() {
    return {
      contact_recipients: [],
      loading: false,
    };
  },
  computed: {
    carrierName() {
      return this.$store.state.carriers?.carrierDetails?.legal_name || '';
    },
    carrierId() {
      return this.$store.state.carriers?.carrierDetails?.id || '';
    },
    maskedContacts() {
      return this.$store.state.carriers?.maskedContacts || [];
    },
    contactRecipients() {
      const contactInformation = this.$store.state.carriers?.carrierDetails;
      return contactInformation?.email_addresses || [];
    },
  },
  async created() {
    await this.$store.dispatch('users/serverRefreshCurrentUser');
    let currentUser = this.$store.state.users.currentUser;
    // Redirect if the user is already associated with a company
    if (currentUser?.company?.id) {
      // TODO validate with Jordan Why this is important.
      // this.$router.push({name: 'Home'})
    }
  },
  methods: {
    // Redirect to OAuth 2 screen if able to
    // create the onboarding packet
    async redirectToCreateDispatcherOnboardingPacket() {
      await this.$store.dispatch('users/serverRefreshCurrentUser');

      console.log('creating onboarding packet');
      const clientId = localStorage.getItem('client_id');
      if (clientId == null) {
        // if there is not client_id in local storage, then
        // send the user to the dashboard
        return this.$router.push({ name: 'Dispatcher Dashboard' });
      }
      let redirectAfterSignIn = JSON.parse(
        localStorage.getItem('redirect_url_after_sigin')
      );
      // If they have a redirect_url_after_signin, take them
      // there else send them to the dashboard
      if (redirectAfterSignIn) {
        // Set the state.dispatchers.selectedCarrierId before
        // going back to OAuth screen in this special use case
        // where they chose the carrier when they signed up
        await this.$store.commit(
          'dispatchers/setSelectedCarrierId',
          this.carrierId
        );
        localStorage.removeItem('redirect_url_after_sigin');
        this.$router.push(redirectAfterSignIn);
      } else {
        return this.$router.push({ name: 'Dispatcher Dashboard' });
      }
    },
    async createDispatcherConnection() {
      const res = await this.$store.dispatch(
        'dispatchers/createDispatcherConnection',
        {
          carrier_id: this.carrierId,
        }
      );
      if ([200, 201].includes(res.status)) {
        await this.redirectToCreateDispatcherOnboardingPacket();
      } else {
        // handle error for updating user details
        toastResponse(this, res, null);
      }
    },
    async handleSubmit() {
      this.loading = true;
      try {
        // TODO Validate the next logic with Jordan - This is something realted with routing logic.
        // await this.createDispatcherConnection();
      } catch (error) {
        console.log(error);
        throw error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
